module.exports = __webpack_public_path__ + "img/pencil.6879fd1a.webp";